<template>

    <div v-if="enquiry!=null">
        <nav class="navbar navbar-expand navbar-primary navbar-dark">
            <!-- Left navbar links -->
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link"  href="#" role="button">TRIP ID - {{enquiry.id}}</a>

                </li>


            </ul>

            <!-- Right navbar links -->
            <ul class="navbar-nav ml-auto">


                <li class="nav-item ml-2" >

                    <a class="nav-link btn-outline-primary"  :href="'/viewenquiry?id='+enquiry.encryptedid" role="button">BACK</a>
                </li>


            </ul>
        </nav>
        <section class="content pt-3">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-3">
                        <div class="col-12 col-sm-12 col-md-12 d-flex align-items-stretch flex-column">
                            <div class="card bg-light d-flex flex-fill">
                                <div class="card-header text-muted border-bottom-0">
                                    TRAVELER DETAIL
                                </div>
                                <div class="card-body pt-0">
                                    <div class="row">
                                        <div class="col-12">
                                            <h2 class="lead"><b>{{enquiry.name}}</b></h2>
                                            <ul class="ml-4 mb-0 fa-ul text-muted">

                                                <li class="small"><span class="fa-li"><i class="fas fa-lg fa-phone"></i></span> Phone : {{enquiry.mobile}}</li>
                                                <li class="small"><span class="fa-li"><i class="fas fa-lg fa-envelope"></i></span> Email : {{enquiry.email_id}}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 d-flex align-items-stretch flex-column">
                            <div class="card bg-light d-flex flex-fill">
                                <div class="card-header text-muted border-bottom-0">
                                    Booking Details
                                </div>
                                <div class="card-body pt-0">
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Booking Date</li>
                                                <li class="small"> {{enquiry.departure_date}}</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted"> Duration</li>
                                                <li class="small" v-if="enquiry.nights>0"> {{enquiry.nights}} Nights {{enquiry.nights+1}} Days</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Departure Date</li>
                                                <li class="small"> {{enquiry.departure_date}}</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Destination</li>
                                                <li class="small">{{enquiry.destinations}}</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Source</li>
                                                <li class="small">{{enquiry.source}}</li>
                                            </ul>
                                        </div>

                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">No. of Travelers</li>
                                                <li class="small">  Adults -  {{enquiry.adults}} </li>
                                                <li class="small">  Childs - {{enquiry.childs}} </li>
                                                <li class="small">  Infants - {{enquiry.infants}} </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Quote Price</li>
                                                <li class="small"> Rs. {{ enquiry.bookingdetails.quote_price}} </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Received Amount</li>
                                                <li class="small"> Rs. {{ enquiry.customerpayments_sum_amount}} </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Pending Amount</li>
                                                <li class="small"> Rs. {{ enquiry.bookingdetails.quote_price-enquiry.customerpayments_sum_amount}} </li>
                                            </ul>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                    <div class="col-md-9">
                        <form @submit.prevent="submit" >
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 d-flex align-items-stretch flex-column">
                                <div class="card bg-light d-flex flex-fill">
                                    <div class="card-header text-muted border-bottom-0">
                                        Basic Details
                                        <div class="card-tools">


                                        </div>
                                    </div>
                                    <div class="card-body pt-0">
                                        <div class="row">


                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label for="date">Date:</label>
                                                    <input type="date" class="form-control"  id="date" v-model="form.date" required>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label for="name">Customer Name:</label>
                                                    <input type="text" class="form-control"  id="name" v-model="form.name" required>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label for="for">For:</label>
                                                    <input type="text" class="form-control"  id="for" v-model="form.forv" required>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label for="quoteprice">Quote Price:</label>
                                                    <input type="number" class="form-control"  id="quoteprice" v-model="form.quoteprice" required>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label for="receivedamount">Received Amount:</label>
                                                    <input type="number" class="form-control"  id="receivedamount" v-model="form.receivedamount" required>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label for="receivedamount">Bank:</label>
                                                    <select class="form-control"  id="bank" v-model="form.bank" required>
                                                        <option  v-for="(bank,index) in banks" :value="index">{{ bank['name']}}</option>
                                                    </select>
                                                </div>
                                            </div>


                                            </div>


                                        </div>
                                    <div class="card-footer">

                                        <input type="submit" class="btn btn-primary float-right" :value="loading?'Please Wait':'Generate'" :disabled="loading">
                                    </div>


                                    <div>

                                    </div>

                                </div>
                            </div>
                        </div>

                        </form>
                    </div>
                </div>
            </div>
        </section>



    </div>

    <div v-if="is_modal_visible" class="modal fade show" id="modal-preview" style="display: block;">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <form ref="form" @submit.prevent="submitsave" >
                    <div class="modal-header">
                        <h4 class="modal-title">Preview</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="is_modal_visible=false">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" ref="previewbody">
                        <iframe :src="pdfsrc" style="width: 100%;height: 500px; border: none;"  ></iframe>

                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-default" data-dismiss="modal" @click="is_modal_visible=false">Close</button>
                       <!-- <button type="submit" class="btn btn-primary" >Save</button>-->
                    </div>
                </form>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>


</template>

<script>
import $ from 'jquery';
import moment from 'moment';
export default {
    name: "GeneareteReceiptVoucher",
    props:['id','banks'],
    data() {
        return {
            is_modal_visible:false,
            hotelnights:[],
            interval: null,
            loading:false,
            enquiry:null,
            pdfsrc:"",
            form:{
                enquiry_id:'',
                date:'',
                name:'',
                forv:'Tour Package',
                quoteprice:'',
                receivedamount:'',
                bank:0
            }

        }
    },
    mounted() {
        this.getdetails();
        this.form.date=moment().format("YYYY-M-D");
        console.log(this.form.date);


    },
    methods: {

        getdetails() {

            let currentObj = this;
            axios.get('/bookingdetails?id='+this.id).then(function (response) {
                currentObj.enquiry=response.data.enquiry;
                currentObj.form.name=currentObj.enquiry.name;
                currentObj.form.quoteprice=currentObj.enquiry.bookingdetails.quote_price;
                currentObj.form.receivedamount=currentObj.enquiry.customerpayments_sum_amount;



            })
                .catch(function (error) {
                });



        },
        submit(e) {
            e.preventDefault();
            let currentObj = this;
            this.loading=true;
            axios.get('/enquiry/vouchers/receiptvouchergenerate', { params: currentObj.form },
                {
                    responseType: 'arraybuffer',

                }).then(function (response) {

                currentObj.loading=false;
                currentObj.is_modal_visible=true;
                var blob = new Blob([response.data], {type: 'application/pdf'});
                currentObj.pdfsrc = window.URL.createObjectURL(blob);
                currentObj.pdfsrc = "data:application/pdf;base64,"+response.data;
               // console.log( currentObj.pdfsrc);




            })
                .catch(function (error) {
                    currentObj.loading=false;
                });

        },



    }
}
</script>

<style scoped>

</style>
